module.exports = __webpack_public_path__ + "media/video608.39b4a919.mp4";